<template>
  <div class="common-content">
    <div class="logo">
      <img src="~images/logo.png" />
    </div>
    <div class="title">
      <div class="bar left"></div>
      <div class="name">
        MEIDASHI<span class="r">®</span>品牌验真系统
      </div>
      <div class="bar right"></div>
    </div>
    <slot></slot>
    <div class="footer">
      Copyright 2021 索尔塔医疗©️版权所有
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceProvider',
  data() {
    return {}
  }
}
</script>

<style lang="less" scopeds>
.common-content{
  width: 100%;
  min-height: 100%;
  background: url('~images/bg.png') no-repeat left top;
  background-size: 100% 100%;
  overflow: auto;
  position: relative;
  .logo{
    width: 239px;
    height: 162px;
    margin: auto;
    padding-top: 65px;
    >img{
      width: 100%;
      height: 100%;
    }
  }
  .title{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 35px 0 50px 0;
    .bar{
      width: 63px;
      height: 4px;
      margin-top: 5px;
      &.left{
        /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#3581fb+0,4ee4ff+100 */
        background: #3581fb; /* Old browsers */
        background: -moz-linear-gradient(left,  #3581fb 0%, #4ee4ff 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(left,  #3581fb 0%,#4ee4ff 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to right,  #3581fb 0%,#4ee4ff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#3581fb', endColorstr='#4ee4ff',GradientType=1 ); /* IE6-9 */
      }
      &.right{
        /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#4ee4ff+0,3581fb+100 */
        background: #4ee4ff; /* Old browsers */
        background: -moz-linear-gradient(left,  #4ee4ff 0%, #3581fb 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(left,  #4ee4ff 0%,#3581fb 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to right,  #4ee4ff 0%,#3581fb 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4ee4ff', endColorstr='#3581fb',GradientType=1 ); /* IE6-9 */
      }
    }
    .name{
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      margin: 0 10px;
      >span{
        display: inline-block;
        &.r{
          transform: scale(0.6) translateY(-10px);
        }
      }
    }
  }
  .footer{
    position: absolute;
    bottom: 60px;
    width: 100%;
    text-align: center;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
  }
}
</style>
